import { DropdownButton } from 'app/components/common/Dropdown';
import { useStore } from 'app/context';
import { FittnessPdfVM } from 'app/stores/ui/agt.fitnesspdf.ui.store';
import { formatBMToYear } from 'app/utils';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';

interface IFitnessPlanPdfDownloadButton {
	agtId: number;
	modifier?: string;
}

export const FitnessPlanPdfDownloadButton = observer((props: IFitnessPlanPdfDownloadButton) => {
	const { documentUiStore, uiStore, session, agtFitnesspdfUiStore } = useStore();

	const [vm, setVm] = useState<FittnessPdfVM | undefined>(undefined);

	const onClick = async (b: number) => {
		try {
			const blob = await documentUiStore.bnrUploadStore.downloadFitnessPdf(props.agtId, 'p', b, true);
			const url = URL.createObjectURL(blob!);
			uiStore.setShowPdf(url);
			return;
		} catch (ex) {
			alert('PDF wurde nicht gefunden.');
			session.decApiCallCount();
		}
	};

	useEffect(() => {
		agtFitnesspdfUiStore.load().then(() => {
			setVm(agtFitnesspdfUiStore.getByAgtId(props.agtId));
		});
	}, [agtFitnesspdfUiStore.items, props.agtId]);

	const mapDropdownItems = (vm: FittnessPdfVM) => {
		return vm.planBms.map((b) => {
			return {
				text: `Fitness Plan PDF ${formatBMToYear(b)}`,
				onClick: () => onClick(b),
			};
		});
	};
	return <>{vm && vm.hasPlan && <DropdownButton className="is-primary is-small is-inverted" text="Fitness Plan PDF" items={mapDropdownItems(vm)} />}</>;
});
